import React from "react";
import { useParams } from "react-router-dom";
import { ProfileCard } from "../../../../components/cards/ProfileCardApplicant";
import References from "./References";
import { Sidebar } from "../Sidebar";
import ProfileTabs from "../ProfileTabs";
import SalaryInformation from "../../../applicant/Onboarding/AdditionalInformation/SalaryInformation";
import CareerObjective from "../../../applicant/Onboarding/AdditionalInformation/CareerObjective";
import Portfolio from "../../../applicant/Onboarding/AdditionalInformation/Portfolio";
import ApplicantFiles from "../../../applicant/Onboarding/AdditionalInformation/ApplicantFiles";
import RelativeInBracInformation from "../../../applicant/Onboarding/AdditionalInformation/RelativeInBracInformation";

export default function AdditionalInformation() {
  const { id } = useParams();

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12 mt-5">
          <div className="main_contents_div">
            <ProfileCard id={id} />
            <ProfileTabs id={id} />
            <CareerObjective id={id} />
            <SalaryInformation id={id} />
            <RelativeInBracInformation id={id} />
            <References id={id} />
            <Portfolio id={id} />
            <ApplicantFiles id={id} />
          </div>
        </div>
      </div>
    </div>
  );
}
